import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import formStyles from '../../../styles/forms.module.scss';
import {
  TextInput,
  RadioGroupInput,
  AccessibleDatepickerInput,
} from '../../../common/FormFields';
import Heading from '../../../common/Heading';
import {
  readCo2KindOfCertificate,
  readInformationStartDate,
} from '../../../utils/coerce';
import s from './StepCertificateForm.module.scss';

type Co2CertificateField =
  | 'consumption'
  | 'kindOfCertificate'
  | 'kindOfContract';

function StepCo2Form() {
  const namePrefix = 'co2CertificateData.';
  const fieldName = (field: Co2CertificateField) => `${namePrefix}${field}`;

  return (
    <section>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.StepCertificateCo2.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name="information.start"
            labelMsg="offerWizard.StepSomeInformation.start.label"
            component={AccessibleDatepickerInput}
            minDate={new Date()}
          />
          <Field
            name="information.end"
            labelMsg="offerWizard.StepSomeInformation.end.label"
            component={AccessibleDatepickerInput}
            minDate={(values: Record<string, unknown>) => {
              const start = readInformationStartDate(values);
              if (start) {
                return new Date(start);
              }
              return new Date();
            }}
          />
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={fieldName('consumption')}
            component={TextInput}
            labelMsg="offerWizard.StepCertificateCo2.consumption.label"
          />
        </div>
        <Field
          captionMsg="offerWizard.StepCertificateCo2.kindOfCertificate"
          name={fieldName('kindOfCertificate')}
          options={[
            {
              value: 'cer',
              labelText: 'Certified Emission Resources (CER)',
            },
            {
              value: 'ver',
              labelText: 'Verified Emission Resources (VER)',
            },
            {
              value: 'eua',
              labelText: 'European Union Allowance (EUA)',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.kindRadios}
        />
        <Field
          captionMsg="offerWizard.StepCertificateCo2.kindOfContract"
          name={fieldName('kindOfContract')}
          renderCondition={(values: Record<string, unknown>) =>
            readCo2KindOfCertificate(values) === 'eua'
          }
          options={[
            {
              value: 'spot_auction',
              labelText: 'Spot/Auktion',
            },
            {
              value: 'future',
              labelText: 'Termin',
            },
          ]}
          component={RadioGroupInput}
          radioButtonsWrapperClass={s.contractKindRadios}
          required
        />
      </div>
    </section>
  );
}

export default StepCo2Form;
